"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var actions_1 = require("../state/actions");
var selectors_1 = require("../state/selectors");
var models_1 = require("@app/_state/models");
var actions_2 = require("@app/features/pending-uploads/state/actions");
var config_1 = require("@app/shared/config");
var initialState = {
    shouldRefresh: false,
    getTransfersIntervalId: 0
};
/**
 * Polls api to refresh state of pluginless uploads
 */
var PluginlessTransferMonitor = /** @class */ (function (_super) {
    __extends(PluginlessTransferMonitor, _super);
    function PluginlessTransferMonitor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = initialState;
        _this.setRefreshInterval = function () {
            var intervalId = window.setInterval(_this.refresh, config_1.Config.PENDING_PACKAGES_REFRESH_INTERVAL);
            _this.setState({ getTransfersIntervalId: intervalId });
        };
        _this.refresh = function () {
            var shouldRefresh = _this.state.shouldRefresh;
            if (shouldRefresh && !_this.props.pluginEnabled && !_this.props.httpGatewayStatus) {
                _this.props.onRefreshTransfers(true);
            }
        };
        return _this;
    }
    PluginlessTransferMonitor.getDerivedStateFromProps = function (nextProps, prevState) {
        // In order to prevent unnecessary server calls, only poll the transfers api if there are any transfers IN_PROGRESS
        // Setting the shouldRefresh state value to true will call the API at each interval specified in PACKAGES_REFRESH_INTERVAL
        var hasInProgressTransfer = nextProps.pendingPackages.findIndex(function (t) { return t.state === models_1.PackageTransferState.IN_PROGRESS; }) > -1;
        return __assign(__assign({}, prevState), { shouldRefresh: hasInProgressTransfer });
    };
    PluginlessTransferMonitor.prototype.componentDidMount = function () {
        this.setRefreshInterval();
    };
    PluginlessTransferMonitor.prototype.componentWillUnmount = function () {
        if (this.state.getTransfersIntervalId) {
            // Make sure to clear the interal when the component is unmounted
            // to prevent it from running even after user has navigated away
            window.clearInterval(this.state.getTransfersIntervalId);
        }
    };
    PluginlessTransferMonitor.prototype.render = function () {
        return null;
    };
    return PluginlessTransferMonitor;
}(react_1.Component));
var mapStateToProps = function (store) {
    return {
        httpGatewayStatus: store.transfers.httpGatewayStatus,
        pendingPackages: store.pendingUploads.pendingUploads.valueSeq().toArray(),
        pluginEnabled: selectors_1.isAsperaEnabled(store)
    };
};
var mapDispatchToProps = {
    onRefreshTransfers: actions_2.refreshPendingTransfers,
    onGetConnectTransfers: actions_1.getAllConnectTransfers
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(PluginlessTransferMonitor);
